(() => {
  const sections = new Map();
  const media = matchMedia('(prefers-reduced-motion: reduce)');
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        entry.target.classList.add('sn-gallery-entered');
        observer.unobserve(entry.target);
      }
    }
  }, { threshold: 0.12 }) : null;
  const init = (root = document) => {
    for (const section of root.querySelectorAll('[data-gallery-section]')) {
      if (sections.has(section)) continue;
      const abort = new AbortController();
      sections.set(section, abort);
      if (!media.matches) observer?.observe(section);
      const track = section.querySelector('[data-gallery-track]');
      if (!track) continue;
      const previous = section.querySelector('[data-gallery-prev]');
      const next = section.querySelector('[data-gallery-next]');
      if (!previous || !next) continue;
      previous.hidden = false;
      next.hidden = false;
      const sync = () => {
        previous.disabled = track.scrollLeft < 3;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 3;
      };
      const move = direction => {
        const width = track.firstElementChild?.getBoundingClientRect().width || track.clientWidth * 0.75;
        track.scrollBy({ left: direction * (width + 26), behavior: media.matches ? 'instant' : 'smooth' });
      };
      previous.addEventListener('click', () => move(-1), { signal: abort.signal });
      next.addEventListener('click', () => move(1), { signal: abort.signal });
      track.addEventListener('scroll', sync, { passive: true, signal: abort.signal });
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        move(event.key === 'ArrowLeft' ? -1 : 1);
      }, { signal: abort.signal });
      window.addEventListener('resize', sync, { passive: true, signal: abort.signal });
      requestAnimationFrame(sync);
    }
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [section, abort] of sections) {
      if (event.target.contains(section)) {
        abort.abort();
        observer?.unobserve(section);
        sections.delete(section);
      }
    }
  });
  media.addEventListener('change', () => {
    if (media.matches) for (const section of sections.keys()) section.classList.remove('sn-gallery-entered');
  });
})();

